import PropTypes from 'prop-types'
import React from 'react'
import { twMerge as mergeClassNames } from 'tailwind-merge'

const STATUS_COLORS = {
  'Not Started': { bg: 'bg-charcoal-100', text: 'text-charcoal-900' },
  'On Outstanding List': { bg: 'bg-charcoal-100', text: 'text-charcoal-900' },
  Closed: { bg: 'bg-blue-200', text: 'text-blue-900' },
  'Closed — Submitted': { bg: 'bg-blue-200', text: 'text-blue-900' },
  Paid: { bg: 'bg-green-800', text: 'text-white' },
  'Written Off': { bg: 'bg-red', text: 'text-white' },
  'Paid with Adjustments': { bg: 'bg-green-800', text: 'text-white' },
}

const StatusBadge = ({ status }) => {
  const colors = STATUS_COLORS[status] || { bg: 'bg-charcoal-100', text: 'text-charcoal-900' }
  return (
    <span
      className={mergeClassNames(
        'inline-block min-w-[140px] rounded-lg px-4 py-2 text-center text-[10px] font-bold uppercase tracking-widest',
        colors.bg,
        colors.text,
      )}
    >
      {status}
    </span>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.string,
}

export default StatusBadge
